import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { ART, CONTACT } from "../data/experiences";

export default function Blog() {
  return (
    <main data-testid="blog-page" className="bg-ivory">
      <header className="editorial-container page-intro">
        <p className="editorial-label mb-6">BLOG</p>
        <h1 className="font-accent text-4xl sm:text-5xl lg:text-6xl text-maroon" data-testid="blog-headline">Reading Delhi.</h1>
        <p className="editorial-body mt-6 max-w-2xl">Essays and field notes on Delhi’s history, culture and everyday life, seen through research, memory and the voices of its neighbourhoods.</p>
      </header>
      <section className="editorial-container community-layout pb-24" data-testid="blog-editorial-section">
        <figure>
          <img src={ART.oldFort} alt="An archival photograph of an old fort gateway in Delhi" width="735" height="480" loading="lazy" className="artwork-image" data-testid="blog-archive-image" />
          <figcaption className="artwork-caption">Delhi, from the supplied archive.</figcaption>
        </figure>
        <div>
          <h2 className="editorial-heading mb-5" data-testid="blog-empty-heading">Stories will be published here.</h2>
          <p className="editorial-body" data-testid="blog-publication-status">There are no published articles here yet. In the meantime, follow Unzip Delhi’s storytelling on Instagram or explore the city with us.</p>
          <div className="mt-7 flex flex-wrap gap-6">
            <a href={CONTACT.instagramUrl} target="_blank" rel="noopener noreferrer" className="editorial-link" data-testid="blog-instagram-link">{CONTACT.instagram} <ArrowRight size={15} /></a>
            <Link to="/experiences" className="editorial-link" data-testid="blog-experiences-link">Explore Experiences <ArrowRight size={15} /></Link>
          </div>
        </div>
      </section>
    </main>
  );
}
